import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetWizardFinishedMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SetWizardFinishedMutationPage = { readonly __typename?: 'RootMutationType', readonly setWizardFinished: { readonly __typename?: 'AccountsUser', readonly id: string } };

export type StartMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type StartMutationPage = { readonly __typename?: 'RootMutationType', readonly start: boolean };

export type UpdateCompanyMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type UpdateCompanyMutationPage = { readonly __typename?: 'RootMutationType', readonly updateCompany: { readonly __typename?: 'AccountsCompany', readonly id: string } };

export type CreateGuestMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type CreateGuestMutationPage = { readonly __typename?: 'RootMutationType', readonly createGuest: { readonly __typename?: 'AccountsGuest', readonly id: string, readonly uuid: string } };


export const SetWizardFinishedDocument = gql`
    mutation SetWizardFinished {
  setWizardFinished {
    id
  }
}
    `;
export type SetWizardFinishedMutationFn = Apollo.MutationFunction<SetWizardFinishedMutationPage, SetWizardFinishedMutationVariables>;

/**
 * __useSetWizardFinishedMutation__
 *
 * To run a mutation, you first call `useSetWizardFinishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWizardFinishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWizardFinishedMutation, { data, loading, error }] = useSetWizardFinishedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetWizardFinishedMutation(baseOptions?: Apollo.MutationHookOptions<SetWizardFinishedMutationPage, SetWizardFinishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWizardFinishedMutationPage, SetWizardFinishedMutationVariables>(SetWizardFinishedDocument, options);
      }
export type SetWizardFinishedMutationHookResult = ReturnType<typeof useSetWizardFinishedMutation>;
export type SetWizardFinishedMutationResult = Apollo.MutationResult<SetWizardFinishedMutationPage>;
export type SetWizardFinishedMutationOptions = Apollo.BaseMutationOptions<SetWizardFinishedMutationPage, SetWizardFinishedMutationVariables>;
export const StartDocument = gql`
    mutation Start($companyId: ID!) {
  start(companyId: $companyId)
}
    `;
export type StartMutationFn = Apollo.MutationFunction<StartMutationPage, StartMutationVariables>;

/**
 * __useStartMutation__
 *
 * To run a mutation, you first call `useStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMutation, { data, loading, error }] = useStartMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStartMutation(baseOptions?: Apollo.MutationHookOptions<StartMutationPage, StartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMutationPage, StartMutationVariables>(StartDocument, options);
      }
export type StartMutationHookResult = ReturnType<typeof useStartMutation>;
export type StartMutationResult = Apollo.MutationResult<StartMutationPage>;
export type StartMutationOptions = Apollo.BaseMutationOptions<StartMutationPage, StartMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: ID!, $name: String!) {
  updateCompany(id: $id, name: $name) {
    id
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutationPage>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutationPage, UpdateCompanyMutationVariables>;
export const CreateGuestDocument = gql`
    mutation CreateGuest($companyId: ID!) {
  createGuest(companyId: $companyId) {
    id
    uuid
  }
}
    `;
export type CreateGuestMutationFn = Apollo.MutationFunction<CreateGuestMutationPage, CreateGuestMutationVariables>;

/**
 * __useCreateGuestMutation__
 *
 * To run a mutation, you first call `useCreateGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuestMutation, { data, loading, error }] = useCreateGuestMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateGuestMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuestMutationPage, CreateGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuestMutationPage, CreateGuestMutationVariables>(CreateGuestDocument, options);
      }
export type CreateGuestMutationHookResult = ReturnType<typeof useCreateGuestMutation>;
export type CreateGuestMutationResult = Apollo.MutationResult<CreateGuestMutationPage>;
export type CreateGuestMutationOptions = Apollo.BaseMutationOptions<CreateGuestMutationPage, CreateGuestMutationVariables>;